import { Params } from '@angular/router';

export const EXPLORE_ACTIVITIES_ROUTE = {
  name: 'exploreactivities',
  route(): string[] {
    return ['/' + this.name];
  },
  queryParams(countryCode: string, regionCode: string, courseId: string): Params {
    return {
      countrycode: encodeURI(countryCode),
      regioncode: encodeURI(regionCode),
      courseid: encodeURI(courseId)
    };
  }
};